export class QuoteRowTemplate  {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly amount: number,
    public readonly price: number,
    public readonly vatRateValue: number,
    public readonly vatRateId: string,
    public readonly ledgerCodeId: string,
    public readonly text: string,
    public readonly includedAttachments: string[],
  ) {
  }

  static fromJson(json: any): QuoteRowTemplate {
    return new QuoteRowTemplate(
      json['id'],
      json['name'],
      json['amount'],
      json['price'],
      json['vat_rate_value'],
      json['vat_rate_id'],
      json['ledger_code_id'],
      json['text'],
      json['included_attachments'] ?? [],
    )
  }
}